import { Menu, Switch } from 'antd';
import { useAppDispatch, useAppSelector, useAppTranslation } from 'app/hooks';
import ConditionButton from 'components/Commons/ConditionButton';
import { Fragment, useState } from 'react';
import {
  selectCurrentConverter,
  setCurrentConverter,
  setIsShowTransactionModal,
} from 'features/home/homeSlice';
import { setLocalStorage } from 'utils/sessionStorage';

interface AccountSubMenuProps {
  logout: () => void;
  handlePromotionClick: () => void;
  handleEventClick: () => void;
  handleUserProfileClick: () => void;
  handleUserBankbookClick: () => void;
  handleWalletConnectClick: () => void;
}

export type MenuType = {
  title: React.ReactNode;
  onClick?: () => void;
};
const AccountSubMenu: React.FunctionComponent<AccountSubMenuProps> = ({
  logout,
  handlePromotionClick,
  handleEventClick,
  handleUserProfileClick,
  handleUserBankbookClick,
  handleWalletConnectClick,
}) => {
  const t = useAppTranslation();
  const dispatch = useAppDispatch();
  const currentConverter = useAppSelector(selectCurrentConverter);

  const handleChangeConverter = (checked: boolean) => {
    if (checked) {
      dispatch(setCurrentConverter('decimal'));
      setLocalStorage('converter', 'decimal');
    } else {
      dispatch(setCurrentConverter('american'));
      setLocalStorage('converter', 'american');
    }
  };

  const menu: MenuType[] = [
    // {
    //   title: (
    //     <Switch
    //       className="odd-format-switch"
    //       checkedChildren="Decimal"
    //       unCheckedChildren="American"
    //       checked={currentConverter === 'decimal'}
    //       onChange={handleChangeConverter}
    //     />
    //   ),
    // },
    {
      title: <p>{t('accountSubMenu.userProfile')}</p>,
      onClick: handleUserProfileClick,
    },
    // {
    //   title: (
    //     <ConditionButton
    //       onClick={handleWalletConnectClick}
    //       className="referral_button"
    //       content={t('common.walletConnect')}
    //     />
    //   ),
    // },
    // {
    //   title: (
    //     <ConditionButton
    //       onClick={handleUserBankbookClick}
    //       className="referral_button"
    //       content={t('accountSubMenu.bankbook')}
    //     />
    //   ),
    // },
    // {
    //   title: (
    //     <ConditionButton
    //       onClick={handleEventClick}
    //       className="referral_button"
    //       content={t('event.title')}
    //     />
    //   ),
    // },
    {
      title: (
        <ConditionButton
          onClick={handlePromotionClick}
          className="referral_button"
          content={t('promotion.title')}
          isSkipCheckOnClick={true}
        />
      ),
    },
    // {
    //   title: (
    //     <ConditionButton
    //       onClick={handleTransactionHistoryClick}
    //       className="referral_button"
    //       content={t('accountSubMenu.transactionHistory')}
    //     />
    //   ),
    // },
    {
      title: <p>{t('accountSubMenu.logout')}</p>,
      onClick: logout,
    },
  ];
  return (
    <Fragment>
      <Menu triggerSubMenuAction={'click'}>
        {menu.map((item, idx) => (
          <Menu.Item
            key={`account-sub-menu-${idx}`}
            className="drop-down-item"
            onClick={item.onClick}
          >
            {item.title}
          </Menu.Item>
        ))}
      </Menu>
    </Fragment>
  );
};

export default AccountSubMenu;
